<template>
  <div>
    <HeadBanner :itemData="$store.state.selected_menu" />
    <Breadcrumb />

    <div class="container">
      <div class="partner-list">
        <PartnerFilter @addFilter="addFilter" @removeFilter="removeFilter" />

        <div class="title-box flex-box between al-center">
          <div class="flex-box column">
            <div class="partner-list-title noto-semibold">
              {{ _.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.conf.header.title') }}
            </div>

            <div class="partner-list-teaser">
              {{ _.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.conf.header.teaser') }}
            </div>
          </div>

          <div class="lead-btn btn sub bg-blue white" @click="popup = true">
            {{ $fn.tr('Leave Contact Information') }}
          </div>
        </div>

        <PartnerDevelopers
          v-if="_.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.conf.enabled')==1"
          :itemData="filteredItems"
        />

        <Pagination2
          class="partner-pagination"
          :pageNumber="pagination.pageNumber"
          :perPage="pagination.perPage"
          :dataLength="getDataLength"
          @set-current="setCurrent"
        />
      </div>
    </div>
    
    <ReasonsSlider class="no-bg"
      v-if="_.get(this.$store.state.current_content, 'secondary.ReasonsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ReasonsSlider')"
    />

    <ProductsSlider
      v-if="_.get(this.$store.state.current_content, 'secondary.ProductsSlider.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.ProductsSlider')"
    />

    <MoreWaysForBanking />

    <CalculatorCurrency
      v-if="_.get(this.$store.state.current_content, 'secondary.CalculatorCurrency.conf.enabled')==1"
      :itemData="_.get(this.$store.state.current_content,'secondary.CalculatorCurrency.data')"
    />

    <portal to="newpopup">
      <DeveloperLeadPopup formName="stock calculator form" formUrl="main/saveLeadForm" @close="popup = false" :class="{ show: popup }" />
    </portal>

    <!-- <CalculatorLoans calcType="ipotekuri"/> -->
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import PartnerFilter from "@/components/PartnerFilter";
import PartnerDevelopers from "@/components/PartnerDevelopers";
import MoreWaysForBanking from "@/components/MoreWaysForBanking";
import ProductsSlider from "@/components/ProductsSlider";
import ReasonsSlider from "@/components/ReasonsSlider";
import CalculatorLoans from "@/components/CalculatorLoans";
import Pagination2 from '@/components/Pagination2';
import DeveloperLeadPopup from "@/components/DeveloperLeadPopup";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    PartnerFilter,
    PartnerDevelopers,
    MoreWaysForBanking,
    ProductsSlider,
    ReasonsSlider,
    CalculatorLoans,
    Pagination2,
    DeveloperLeadPopup,
  },
  data() {
    return {
      transfers: false,
      filteredBy: [],
      filteredItems: [],
      pagination: {
					pageNumber: 1,
					perPage: 12,
				},
      popup: false,
    };
  },

  methods: {
    filterItems() {
      if (this.filteredBy.length) {
        let filtered = _.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.data');

        if (this.filteredBy.includes("developers") && this.$store.state.developerFilter.length && !this.$store.state.developerFilter.includes("all")) {
          filtered = filtered.filter(item => item.developers && item.developers.length && item.developers.some(x => this.$store.state.developerFilter.includes(x)));
        }

        if (this.filteredBy.includes("developers_project_status") && this.$store.state.statusFilter.length && !this.$store.state.statusFilter.includes("all")) {
          filtered = filtered.filter(item => item.developers_project_status && item.developers_project_status.length && item.developers_project_status.some(x => this.$store.state.statusFilter.includes(x)));
        }

        if (this.filteredBy.includes("developers_location") && this.$store.state.cityFilter.length && !this.$store.state.cityFilter.includes("all")) {
          filtered = filtered.filter(item => item.developers_location && item.developers_location.length && item.developers_location.some(x => this.$store.state.cityFilter.includes(x)));
        }

        if (this.filteredBy.includes("developers_location_region") && this.$store.state.regionFilter.length && !this.$store.state.regionFilter.includes("all")) {
          filtered = filtered.filter(item => item.developers_location && item.developers_location.length && item.developers_location.some(x => this.$store.state.regionFilter.includes(x)));
        }

        if (this.filteredBy.includes("search") && this.$store.state.searchFilter) {
          filtered = filtered.filter(item => item.title.includes(this.$store.state.searchFilter) || item.teaser.includes(this.$store.state.searchFilter));
        }

        const startIndex = (this.pagination.pageNumber - 1) * this.pagination.perPage;
        const endIndex = startIndex + this.pagination.perPage;
        this.filteredItems = filtered.slice(startIndex, endIndex);
      } else {
        const startIndex = (this.pagination.pageNumber - 1) * this.pagination.perPage;
        const endIndex = startIndex + this.pagination.perPage;
        this.filteredItems = _.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.data').slice(startIndex, endIndex);
      }
    },
    addFilter(taxName) {
      if (!this.filteredBy.includes(taxName)) {
        this.filteredBy.push(taxName);
      }

      this.filterItems();
    },
    removeFilter(taxName) {
      const index = this.filteredBy.findIndex(x => x === taxName);
      if (index > -1) {
        this.filteredBy.splice(index, 1);
      }

      this.filterItems();
    },
    setCurrent(current) {
      if (!parseInt(current)) return this.$set(this.pagination, "pageNumber", 1);

      this.$set(this.pagination, "pageNumber", current);

      this.filterItems();
    },
  },

  computed: {
    getDataLength() {
      if (
        _.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.conf.listCount')
      )
        return parseInt(_.get(this.$store.state.current_content, 'secondary.PartnerDevelopers.conf.listCount'));

      return this.pagination.perPage;
    },
  },

  mounted() {
    const startIndex = (this.pagination.pageNumber - 1) * this.pagination.perPage;
    const endIndex = startIndex + this.pagination.perPage;
    this.filteredItems = _.get(this.$store.state.current_content,'secondary.PartnerDevelopers.data').slice(startIndex, endIndex);
  },

  watch: {
    // "$store.state.current_content.primary":{
    //       immediate: true,
    //       handler: function() {
    //           this.transfers = this.$store.state.current_content.primary;
    //       }
    //   },
  },
};
</script>

<style>
.no-bg.reasonsSliderContainer{
  margin-bottom: 90px;
}
.no-bg.reasonsSliderContainer:after{
  display: none;
}
.lead-btn {
  padding: 0 20px;
  cursor: pointer;
}
@media(max-width: 767px){
  .no-bg.reasonsSliderContainer{
    margin-bottom: 55px;
  }

  .title-box {
    align-items: flex-start !important;
    flex-direction: column;
  }

  .lead-btn {
    height: 50px;
    margin-top: 20px;
  }
}
</style>